import { GATEWAY_FETCH_UNREACHABLE_MESSAGE } from '@/core/const/gatewayFetchUnreachableMessage.const'

const isAbortOrTimeoutError = (error: unknown): boolean =>
  error instanceof Error && (error.name === 'AbortError' || error.name === 'TimeoutError')

export function mapGatewayFetchError(error: unknown): Error {
  if (error instanceof TypeError || isAbortOrTimeoutError(error)) {
    return new Error(GATEWAY_FETCH_UNREACHABLE_MESSAGE)
  }

  if (error instanceof Error) {
    return error
  }

  return new Error(GATEWAY_FETCH_UNREACHABLE_MESSAGE)
}
